import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Prisma } from '@prisma/client';
import showingsService from '../../api/services/showings';
import messagesService from '../../api/services/messages';

export type messagesWithSenderAndReceiver = Prisma.messagesGetPayload<{
  include: { sender: true; receiver: true };
}>[];

interface State {
  messages: messagesWithSenderAndReceiver;
  loading: boolean;
  error: string | null;
}

const initialState: State = {
  messages: [],
  loading: false,
  error: null,
};

export const fetchMessages = createAsyncThunk(
  'messages/fetch',
  async (_params, { rejectWithValue }) => {
    try {
      const clients = await messagesService.find();
      return clients;
    } catch (error) {
      return rejectWithValue('Failed to fetch messages');
    }
  }
);

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchMessages.fulfilled,
        (state, action: PayloadAction<messagesWithSenderAndReceiver>) => {
          state.loading = false;
          state.messages = action.payload;
        }
      )
      .addCase(fetchMessages.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default messagesSlice.reducer;
